import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-clinic-inclusions',
  templateUrl: './clinic-inclusions.component.html',
  styleUrls: ['./clinic-inclusions.component.css'],
  standalone: false
})
export class ClinicInclusionsComponent {

  @Input() quote: any;
  constructor(private translate: TranslateService) {

  }

  get allServices() {
    return [
      {
        included: this.quote?.flightIncluded,
        icon: 'plane',
        label: this.translate.instant('Flight Included')
      },
      {
        included: this.quote?.accommodationIncluded,
        icon: 'building',
        label: this.translate.instant('Hotel Included')
      },
      {
        included: this.quote?.isFinanceable,
        icon: 'coins',
        label: this.translate.instant('Financeable')
      },
      {
        included: this.quote?.hasTransportToClinic,
        icon: 'car',
        label: this.translate.instant('Transport to clinic')
      }
    ];
  }


}
